const fixHeight = () => {
    let fixBlocks = document.querySelectorAll('.js-fix-height');
    let hmax = 0;
    fixBlocks.forEach((block, index) => {
        block.style.minHeight = 0;
        const blockHeight = block.clientHeight;
        if(blockHeight>hmax){
            hmax = blockHeight;
        }
    });
    fixBlocks.forEach((block, index) => {
        block.style.minHeight = hmax + 'px';
    });
}

document.addEventListener("DOMContentLoaded", () => {
    fixHeight();
});


window.addEventListener("resize", () => {
    fixHeight();
});

window.addEventListener("load", () => {
    setTimeout(()=>{
        fixHeight();
    },1000);
});
